export const QUBIC_WALLET_LAST_CACHED_INDEXES_LOCAL_STORAGE_KEY =
    'qubic-ledger-wallet_last-cached-index';

export const MAX_ADDRESS_INDEX = 255;

export const DEFAULT_TICK_INTERVAL_FOR_TRANSACTIONS = 200000;
